import { connect } from 'react-redux';

import { setShoppingListView } from 'Favourites/store/actions';

import {
    selectExcludeVAT,
} from 'store/reducers/data/user';
import appStorage from 'helpers/AppStorage';


import {
    selectShoppingListView,
} from 'store/reducers/data/shoppingList';

const mapStateToProps = (state) => {
    return {
        excludeVAT: selectExcludeVAT(state),
        view: selectShoppingListView(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        triggerShoppingListViewChange: (value) => {
            dispatch(setShoppingListView(value));
            appStorage('shoppingListView', value);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
